import { Trans, useTranslation } from "react-i18next"
import Header from "../header/HeaderComponent"
import Footer from "../footer/FooterComponent"
import Seo from "../Seo/SeoComponent"
import styles from "./privacyPolicyPage.module.scss"
import PageLanguageLink from "../PageLanguageLink/PageLanguageLink";

export default function PrivacyPolicyPage() {
    const { t, i18n } = useTranslation("privacyPolicyPage")
    const isPt = i18n.language === "pt"
    const switchPath = isPt ? "/privacy-policy" : "/pt/privacy-policy"
    const currentPath = isPt ? "/pt/privacy-policy" : "/privacy-policy"

    return (
        <div className={styles.page}>
            <Seo
                title={t("seoTitle")}
                description={t("seoDescription")}
                path={currentPath}
                lang={isPt ? "pt-PT" : undefined}
            />
            <Header />

            <main className={styles.main}>
                <section className={styles.container}>
                    <h1 className={styles.title}>{t("title")}</h1>

                    <p className={styles.text}>{t("intro")}</p>

                    <h2>{t("cookies.heading")}</h2>
                    <p className={styles.text}>{t("cookies.p1")}</p>
                    <p className={styles.text}>{t("cookies.p2")}</p>
                    <p className={styles.text}>
                        <Trans i18nKey="cookies.p3" ns="privacyPolicyPage">
                            You can review or withdraw optional consent using <strong>Cookie settings</strong> in the footer. You can also delete cookies and site storage in your browser; doing so may sign you out and remove locally saved progress and connections. Our <a href="https://www.iubenda.com/privacy-policy/46335044/cookie-policy">cookie policy</a> provides further information about trackers and their duration.
                        </Trans>
                    </p>

                    <h2>{t("analytics.heading")}</h2>
                    <p className={styles.text}>{t("analytics.p1")}</p>
                    <p className={styles.text}>
                        <Trans i18nKey="analytics.p2" ns="privacyPolicyPage">
                            PostHog, Sentry, and CloudWatch RUM are enabled by measurement consent. Sentry session replay samples 10% of sessions and records all sessions where an error occurs; it masks page text and inputs and does not capture request or response bodies. CloudWatch RUM samples 10% of sessions and records page views, load performance, JavaScript and HTTP errors, and browser, device, and session information, plus the same product events sent to the other analytics tools. After consent it sets two cookies, <strong>cwr_u</strong> (a browser identifier, about 30 days) and <strong>cwr_s</strong> (the current session, which expires within the day), and stores temporary access credentials for its AWS service in your browser's local storage. Google Analytics is controlled through iubenda's Google Consent Mode integration; depending on that configuration, Google may receive cookieless measurement signals when analytics storage is denied. We do not intentionally include passwords, email addresses, or the text you type in our custom analytics events. PostHog automatic click capture is disabled. Session recording is disabled by default; if enabled, it uses measurement consent and masks page text and inputs.
                        </Trans>
                    </p>
                    <p className={styles.text}>{t("analytics.p3")}</p>
                    <p className={styles.text}>
                        <Trans i18nKey="analytics.p4" ns="privacyPolicyPage">
                            See the providers' information about their processing: <a href="https://policies.google.com/privacy">Google Privacy Policy</a>, <a href="https://posthog.com/privacy">PostHog Privacy Policy</a>, <a href="https://sentry.io/privacy/">Sentry Privacy Policy</a>, and the <a href="https://aws.amazon.com/privacy/">AWS Privacy Notice</a>.
                        </Trans>
                    </p>

                    <h2>{t("accounts.heading")}</h2>
                    <p className={styles.text}>{t("accounts.p1")}</p>

                    <h2>{t("connected.heading")}</h2>
                    <p className={styles.text}>{t("connected.p1")}</p>
                    <p className={styles.text}>{t("connected.p2")}</p>
                    <p className={styles.text}>{t("connected.p3")}</p>

                    <h2>{t("otherServices.heading")}</h2>
                    <p className={styles.text}>{t("otherServices.p1")}</p>
                    <p className={styles.text}>{t("otherServices.p2")}</p>
                    <p className={styles.text}>{t("otherServices.p3")}</p>

                    <h2>{t("security.heading")}</h2>
                    <p className={styles.text}>{t("security.p1")}</p>
                    <p className={styles.text}>{t("security.p2")}</p>
                    <p className={styles.text}>
                        <Trans i18nKey="security.p3" ns="privacyPolicyPage">
                            To ask about access, correction, export, deletion, or how long particular records are retained, contact <a href="mailto:admin@teqseq.com">admin@teqseq.com</a>. You can change cookie preferences at any time without deleting your account.
                        </Trans>
                    </p>

                    <p className={styles.updated}>{t("updated")}</p>

                    <PageLanguageLink to={switchPath} />
                </section>
            </main>

            <Footer />
        </div>
    )
}
